export let SignatureFont = /*#__PURE__*/function (SignatureFont) {
  SignatureFont["AlexBrush"] = "Alex Brush";
  SignatureFont["Allura"] = "Allura";
  SignatureFont["AmaticSC"] = "Amatic SC";
  SignatureFont["AnnieUseYourTelescope"] = "Annie Use Your Telescope";
  SignatureFont["DancingScript"] = "Dancing Script";
  SignatureFont["GreatVibes"] = "Great Vibes";
  SignatureFont["IndieFlower"] = "Indie Flower";
  SignatureFont["Kristi"] = "Kristi";
  SignatureFont["LaBelleAurore"] = "La Belle Aurore";
  SignatureFont["MeieScript"] = "Meie Script";
  SignatureFont["MrsSaintDelafield"] = "Mrs Saint Delafield";
  SignatureFont["NanumPenScript"] = "Nanum Pen Script";
  SignatureFont["OvertheRainbow"] = "Over the Rainbow";
  SignatureFont["Qwigley"] = "Qwigley";
  SignatureFont["ReenieBeanie"] = "Reenie Beanie";
  SignatureFont["SueEllenFrancisco"] = "Sue Ellen Francisco";
  return SignatureFont;
}({});
export const SIGNATURE_FONT_MEMBERS = Object.values(SignatureFont);